<template>
  <div>
    <v-text-field
      v-model="passwordModel.password"
      :data-testid="testId ? testId + '-input' : null"
      :label="$t('NewPwd') + '*'"
      type="password"
      :error="showError"
      :error-messages="errorArray"
      autocomplete="new-password"
      dense
      required
      @blur="onPasswordBlur"
      @input="$emit('validation-changed')"
    ></v-text-field>

    <v-text-field
      v-model="passwordModel.repeatPassword"
      :data-testid="testId ? testId + '-repeat-input' : null"
      :label="$t('NewPwdConfirm') + '*'"
      type="password"
      :error="showError"
      autocomplete="new-password-repeat"
      required
      @blur="onPasswordBlur"
      @input="$emit('validation-changed')"
    ></v-text-field>
  </div>
</template>
<script>
import { PasswordModel } from '../../../model/password/Password'
import { clientTranslator } from '../../../i18n'

export default {
  name: 'HdPasswordFields',
  props: {
    passwordPolicy: {
      type: Number,
      required: true,
    },
    canBeEmpty: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    testId: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      passwordModel: new PasswordModel({passwordPolicy: this.$store.state.user.passwordPolicies[this.passwordPolicy] }),
      hasBeenValidated: false,
    }
  },
  computed: {
    errorArray(){
      const errors = this.passwordModel.errorMessages.map((e) => {
        if(e === this.$t(e) && e.includes('[')) {
          return clientTranslator(e)
        }
        return this.$t(e)
      })
      // Add required error if password is empty and mandatory
      if (this.hasBeenValidated && !this.canBeEmpty && !this.passwordModel.password) {
        if (errors.length === 0) {
          return [' ']
        }
      }
      return errors
    },
    showError() {
      if (!this.hasBeenValidated) {
        return false
      }
      // Show error if password is empty and mandatory
      if (!this.canBeEmpty && !this.passwordModel.password) {
        return true
      }
      return !this.passwordModel.isValid
    }
  },
  watch: {
    passwordPolicy: function(newVal) {
      this.passwordModel = new PasswordModel({passwordPolicy: this.$store.state.user.passwordPolicies[newVal] })
    },
    'passwordModel.password': function(newVal) {
        this.passwordModel.dirty = !!newVal
        this.passwordModel.validate(this.canBeEmpty)
        if (this.hasBeenValidated) {
          this.$forceUpdate()
        }
    },
    'passwordModel.repeatPassword': function() {
        this.passwordModel.validate(this.canBeEmpty)
        if (this.hasBeenValidated) {
          this.$forceUpdate()
        }
    },
  },
  
  methods: {
    /**
     * Returns selection value
     */
    getValue() {  
      return this.passwordModel.password !== '' ? this.passwordModel.password : undefined
    },
    validate() {
      this.hasBeenValidated = true
      this.passwordModel.validate(this.canBeEmpty)
      // If password is empty and mandatory, mark as invalid
      if (!this.canBeEmpty && !this.passwordModel.password) {
        this.passwordModel.isValid = false
      }
      return this.passwordModel.isValid
    },
    onPasswordBlur() {
      this.hasBeenValidated = true
      this.passwordModel.validate(this.canBeEmpty)
      // If password is empty and mandatory, mark as invalid
      if (!this.canBeEmpty && !this.passwordModel.password) {
        this.passwordModel.isValid = false
      }
    },
    clear() {
      this.passwordModel.password = ''
      this.passwordModel.repeatPassword = ''
    }
  }
}

</script>